export default __webpack_public_path__ + "static/wood3-97368d916540f44018b98010ed751d95.png";